import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ReferenceCardSkeleton() {
  return (
    <div
      className={cn(
        'animate-pulse',
        'col-span-1 h-[280px] w-full bg-neutral-100 sm:h-[300px] md:h-[320px] lg:h-[390px]',
      )}
    />
  );
}
